import { BillingDetails, ShopDetails } from '../models';
import { MAP_REQUIRED_BILLING_PROPS_TO_TEXT } from './constants';

export function getMissingBillingPropsToText(shopDetails: ShopDetails): string {
  return Object.entries(MAP_REQUIRED_BILLING_PROPS_TO_TEXT)
    .reduce<string>((acc, [key, value]) => {
    if (!shopDetails[key as keyof BillingDetails]) {
      const divider = acc.length ? ', ' : '';
      return acc.concat(divider + value);
    }
    return acc;
  }, '');
}
